import { yup } from '@guiker/shared-framework'

export const completeListingInquirySchema = yup.object({
  listingId: yup.string().required(),
  rentalOptionId: yup.string().optional().nullable(),
  moveInDate: yup.string().optional().nullable(),
  message: yup.string().optional().nullable(),
})
